import { createApi } from '@reduxjs/toolkit/query/react';

import { apiForms } from '~constants/api';
import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import {
  CompletedForm,
  CompletedFormListItem,
  CreateCompletedFormRequest,
  ResolveRequest,
  ResolveResponse,
} from '~forms/types';

export const completedFormsApi = createApi({
  reducerPath: 'completedFormsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiForms }),
  tagTypes: ['completedFormList', 'completedForm'],
  endpoints: (builder) => ({
    resolveMergeFields: builder.mutation<ResolveResponse, ResolveRequest>({
      query: (body) => ({ url: '/resolve', method: 'POST', body }),
      transformResponse: (payload) => unwrap<ResolveResponse>(payload),
    }),

    createCompleted: builder.mutation<CompletedForm, CreateCompletedFormRequest>({
      query: (body) => ({ url: '/completed', method: 'POST', body }),
      transformResponse: (payload) => unwrap<CompletedForm>(payload),
      invalidatesTags: [{ type: 'completedFormList', id: 'LIST' }],
    }),

    getCompletedList: builder.query<CompletedFormListItem[], void>({
      query: () => ({ url: '/completed', method: 'GET' }),
      transformResponse: (payload) => unwrap<CompletedFormListItem[]>(payload),
      providesTags: [{ type: 'completedFormList', id: 'LIST' }],
    }),

    getCompleted: builder.query<CompletedForm, string>({
      query: (id) => ({ url: `/completed/${id}`, method: 'GET' }),
      transformResponse: (payload) => unwrap<CompletedForm>(payload),
      providesTags: (_r, _e, id) => [{ type: 'completedForm', id }],
    }),
  }),
});

export const {
  useResolveMergeFieldsMutation,
  useCreateCompletedMutation,
  useGetCompletedListQuery,
  useGetCompletedQuery,
} = completedFormsApi;
